import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconCloseCircle } from '../../assets/icons/IconCloseCircle';
import { RelanceForecast } from '../../features/relance/RelanceForecast';
import { useAppNavigate } from '../../hooks/useAppNavigate';
import { TranslationKey } from '../../i18n/translationKeys';
import { UPCOMING_RELANCES_ROUTE } from '../../routes/paths';
import { SeeAllLink } from '../../ui/SeeAllLink/SeeAllLink';
import { HOME_UPCOMING_DAYS } from '../../utils/relance/relanceHorizon';
import { buildForecastDays } from '../../utils/relance/forecastDays';
import type { HomeUpcomingRelancesProps } from './types';

export const HomeUpcomingRelances: React.FC<HomeUpcomingRelancesProps> = ({ upcoming, canCollectPayment }) => {
    const { t } = useTranslation();
    const appNavigate = useAppNavigate();
    const days = useMemo(
        () => buildForecastDays(upcoming, HOME_UPCOMING_DAYS).filter(d => d.entries.length > 0),
        [upcoming],
    );

    if (upcoming.length === 0) return null;

    const count = days.reduce((sum, d) => sum + d.entries.length, 0);

    return (
        <section aria-labelledby="home-upcoming-heading" data-testid="home-section-upcoming" className="flex flex-col gap-xl">
            <h2 id="home-upcoming-heading" className="text-block-title-emphasized text-content">
                {t(TranslationKey.Home.Agenda.UpcomingTitle, { count })}
            </h2>
            {count === 0 ? (
                <p className="flex items-center gap-s text-m font-normal text-content-secondary" data-testid="home-upcoming-empty-week">
                    <IconCloseCircle className="size-4 shrink-0 text-content-tertiary" />
                    {t(TranslationKey.Home.Agenda.UpcomingEmptyWeek)}
                </p>
            ) : (
                <RelanceForecast days={days} canCollectPayment={canCollectPayment} testId="home-upcoming-agenda" />
            )}
            <SeeAllLink className="w-fit" data-testid="home-upcoming-see-all" onClick={() => appNavigate(UPCOMING_RELANCES_ROUTE)}>
                {t(TranslationKey.Home.Agenda.UpcomingSeeAll)}
            </SeeAllLink>
        </section>
    );
};
